import { FieldProps, BooleanSchema, FieldChangeEvent } from '../types';
import { RadioGroupField } from './RadioGroupField';

const yesNoToBoolean = (value: string | null) => {
  switch (value) {
    case 'yes':
      return true;
    case 'no':
      return false;
    default:
      return null;
  }
};

const booleanToYesNo = (value: boolean | null | undefined) => {
  if (value === true) {
    return 'yes';
  }
  if (value === false) {
    return 'no';
  }
  return null;
};

type YesNoFieldProps = FieldProps<BooleanSchema> & {
  value: boolean;
};

export const YesNoField = (props: YesNoFieldProps) => {
  const onChange = (e: FieldChangeEvent) => {
    const { name, value } = e.target;
    return props.onChange({
      target: {
        name,
        value: yesNoToBoolean(value)
      }
    });
  };

  function getEnumOrder(): Array<'yes' | 'no'> {
    if (props.schema.enum) {
      return props.schema.enum[0] === true ? ['yes', 'no'] : ['no', 'yes'];
    }

    return ['yes', 'no'];
  }

  return (
    <RadioGroupField
      {...props}
      schema={{
        enumNames: props.schema.enumNames,
        title: props.schema.title,
        description: props.schema.description,
        default: undefined,
        type: 'string',
        enum: getEnumOrder(),
        $uiOptions: {
          hint: props.schema.$uiOptions?.hint
        }
      }}
      value={booleanToYesNo(props.value)}
      onChange={onChange}
    />
  );
};
